import {Component, OnInit} from '@angular/core';
import {MenuSet, MenuSetsService} from "../../../services/menu-sets.service";

@Component({
  selector: 'menu-sets-list',
  templateUrl: 'menu-sets-list.component.html'
})

export class MenuSetsListComponent implements OnInit {
  menuSets: MenuSet[];

  constructor(private menuSetsService: MenuSetsService) {
  }

  ngOnInit() {
    this.menuSetsService
      .getMenuSetsList()
      .subscribe(data => this.menuSets = data);
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/menu-sets-list/menu-sets-list.component.ts